<template>
  <div class="flex">
    <div class="pr-5">
      <button
        class="flex items-center focus:outline-none"
        @click="$emit('click')"
      >
        <OSvg svg="arrow-left" class="h-4 fill-gray-400 pt-1" />
        <span class="lg:hidden" v-text="$t('Loyalty.Breadcrumbs.Back')" />
        <span class="hidden lg:inline" v-text="$t('Loyalty.Breadcrumbs.BackToOverview')" />
      </button>
    </div>
    <div class="flex items-center">
      <ul class="flex">
        <li
          v-for="({ title, link }, index) in breadcrumbs"
          :key="`${title}-${index}`"
          class="relative"
          :class="{
            'pr-2 text-gray-400 right-border-gray-400': isFirstItem(index),
            'px-2 text-gray-400 right-border-gray-400': !isFirstItem(index) && !isLastItem(index),
            'pl-2 text-gray-600': isLastItem(index)
          }"
        >
          <NuxtLink
            v-if="link"
            :to="link"
            class="ota-p12 font-semibold"
          >
            {{ title }}
          </NuxtLink>
          <span v-else class="ota-p12 font-semibold" v-text="title" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { breadcrumbs } from '@/components/Webshop/props'
import OSvg from '@/components/OSvg'

export default {
  name: 'BreadCrumbs',
  components: { OSvg },
  props: {
    breadcrumbs
  },
  methods: {
    isFirstItem (index) {
      return index === 0
    },
    isLastItem (index) {
      return index + 1 === this.breadcrumbs.length
    }
  }
}
</script>

<style lang="postcss" scoped>
button {
  @apply text-gray-400 bg-white border border-gray-400 px-3 py-1 rounded;
  font-size: 1.2rem;

  span {
    padding-top: .2rem;
  }
}

.right-border-gray-400::after {
  @apply absolute bg-gray-400 my-auto top-0 bottom-0;
  content: "";
  right: -0.1rem;
  height: 83%;
  width: .2rem;
}
</style>
